import $ from 'jquery';

export default {

	init() {

		// Check Query Strings
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop)
		});

		// Variables
		let term_id = params.term_id;
		let searchInput = params.search;
		var pageNumber = 1;
		var doNotDuplicate = $('#more-posts').data('donotduplicate');

		function load_posts() {
			pageNumber++;
			$.ajax({
				type: "POST",
				dataType: "html",
				url: ajax_object.ajax_url,
				data: {
					action: 'more_post_ajax_nba',
					term_id: term_id,
					pageNumber: pageNumber,
					searchInput: searchInput,
					doNotDuplicate: doNotDuplicate
				},
				success: function(data) {
					var $data = $(data);
					if($data.length) {
						$("#ajax-posts").append($data);
						$("#more-posts").attr("disabled", false);
					} else {
						$("#more-posts").attr("disabled", true);
						$(".no-more").addClass("block").removeClass("hidden");
						$(".load-more").addClass("hidden").removeClass("block");
					}
				},
				error: function(jqXHR, textStatus, errorThrown) {
					$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
				}

			});
			return false;
		}

		$(".load-more").on("click", function() { // When btn is pressed.
			load_posts();
		});

		// Change active category
		if(term_id && term_id !== "" && !searchInput) {
			$('.cat-list_item').removeClass('border-orange');
			$('.cat-list_item[data-term_id=' + term_id + ']').addClass('border-orange');

			$('#originalList').hide('fast');
			// $('html,body').delay(200).animate({scrollTop:$("#standard").offset().top}, 400);

		} else if(searchInput && searchInput != "") {
			$('#more-posts').hide();
			$('#results').show();
			$('#results span').html(searchInput);

		} else {
			$('#featured').fadeIn('fast');
			$('#recent').fadeIn('fast');
		}

		// When category is selected, atribute new query strings and refresh the page
		$('.cat-list_item').on('click', function() {

			var term_id = $(this).data('term_id');
			$('#featured').fadeOut();
			$('.load-more').attr('data-term_id', term_id);
			var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?term_id=' + term_id;
			window.history.pushState({path: newurl}, '', newurl);
			location.reload();

		});

	}

};
